import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const resetPassword = (values) =>
  Manager.client().get(
    `${Endpoints.auth.resetPassword}?username=${values.username}`,
  );
const changePassword = ({ access }, values) =>
  Manager.client(access).post(Endpoints.auth.changePassword, values);
const resetConfirmPassword = (values) =>
  Manager.client().post(Endpoints.auth.resetPassword, values);

export const Request = {
  resetPassword,
  changePassword,
  resetConfirmPassword,
};
